import React from 'react'
import MainLayout from '../layout/MainLayout'
import { useState } from 'react';

function ErrorPage() {

    const [launchDate] = useState(() => new Date(2026, 8, 24));
    const [today] = useState(() => new Date());
    const [daysOld] = useState(() => Math.round((today - launchDate) / (1000 * 60 * 60 * 24)));


    return (
        <MainLayout>
            <div className="text-content">

                <h1>Oops. </h1>
                <br />Sorry - That wasn't supposed to happen. .
                <br />We obviously missed testing that.
                <p />
                <p>But, hey, we launched on {launchDate.toLocaleDateString()}, so we're only {daysOld} days old....</p>

                <p /><p />The error has been logged and we'll look into it.
            </div>
        </MainLayout>
    )
}

export default ErrorPage
